import { EXCLUDE_OPT } from '../AssetBucketSelect/AssetBucketSelect.meta';

interface Params {
  options: { defaultBucketIndex: number | null; label: string; value: number }[];
  setValue(value: number): void;
}

export const onManagementSelect = ({ options, setValue }: Params) => (value: number | null) => {
  if (value !== null) {
    const assetBucketIndex = options.find(option => option.value === value);
    if (assetBucketIndex) {
      setValue(
        assetBucketIndex.defaultBucketIndex === null
          ? EXCLUDE_OPT.value
          : assetBucketIndex.defaultBucketIndex,
      );
    }
  }
};
